import { hardUpdateDataAll, updateInputNames, setFieldsetData, updateDataAll, fildsetInit } from './fieldsetData';

export function attachEventListeners(managerInstance) {
  document.body.addEventListener('input', handleChange);
  document.body.addEventListener('change', handleChange);
  document.body.addEventListener('click', _handleDisableTab);
  document.body.addEventListener('fieldsetUpdated', handleUpdateParentFildset);

  document.querySelectorAll('fieldset').forEach((fieldset) => {
    fildsetInit(fieldset);
  });
}

function handleUpdateParentFildset(event) {
  const fieldset = event.detail.fieldset.parentNode.closest('fieldset');
  if (!fieldset) {
    return;
  }
  updateDataAll(fieldset);
}

function handleChange(event) {
  let currentFieldset = event.target.closest('fieldset:not([disabled])');
  if (currentFieldset) {
    updateDataAll(currentFieldset);
  }
}

function _handleDisableTab(event) {
  if (!event.target.matches('[data-bs-toggle="tab"][data-bs-toggle-type="disableTab"]')) return;
  const targetId = event.target.getAttribute('data-bs-target');
  const tabContent = document.querySelector(targetId).closest('.tab-content');
  const fieldsets = tabContent.querySelectorAll('fieldset');

  fieldsets.forEach((fieldset) => {
    fieldset.disabled = true;
    setFieldsetData(fieldset, null);
  });

  const activeFieldsets = document.querySelector(targetId).querySelectorAll('fieldset');
  activeFieldsets.forEach((fieldset) => {
    fieldset.disabled = false;
  });
}
